module.exports = __webpack_public_path__ + "img/calendarIcon.bf0c24fc.svg";